import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { d as dataResponse } from "./utils-43004f5a.js";
import { postSecureAccountsApi } from "@Shared/utils/ajax";
class NylasIdentityRequestWrapper {
  constructor(session) {
    this.defaultAuthArgs = [];
    this.session = session;
  }
  setActiveGrantId(grantId) {
    this.activeGrantId = grantId;
  }
  async request({
    method,
    path,
    body,
    headers
  }) {
    const grantString = localStorage.getItem("grant");
    const grant = grantString ? JSON.parse(grantString) : null;
    const accessToken = grant ? grant.access_token : null;
    try {
      let response;
      if (path === "calendars") {
        response = await postSecureAccountsApi(_objectSpread(_objectSpread({}, body), {}, {
          method,
          token: accessToken
        }), `/grants/me/${path}`);
      } else if (_includesInstanceProperty(path).call(path, "configurations")) {
        var _context;
        let data = {
          method,
          token: accessToken
        };
        if (_includesInstanceProperty(_context = ["POST", "PUT"]).call(_context, method)) {
          data = _objectSpread(_objectSpread({}, data), body);
        }
        response = await postSecureAccountsApi(data, `/grants/me/${path}`);
      } else {
        response = await this.session.fetch(`grants/me/${path}`, _objectSpread({
          method,
          headers: headers ? new Headers(headers) : undefined,
          body
        }, this.session.isMultiAccount() && this.activeGrantId ? {
          grant_id: this.activeGrantId
        } : {}));
      }
      if (typeof response === "undefined") {
        throw new Error("Response is undefined");
      }
      return dataResponse(response);
    } catch (error) {
      var _context2;
      let errorMessage = String(error);
      if (_includesInstanceProperty(_context2 = String(error)).call(_context2, "Access token not found")) {
        errorMessage = "Session expired, please log in again. Redirecting...";
        setTimeout(() => {
          localStorage.removeItem("grant");
          localStorage.removeItem("user");
          window.location.reload();
        }, 1000);
      }
      return dataResponse(null, {
        message: errorMessage
      });
    }
  }
  async currentUser() {
    const grantId = this.session.isMultiAccount() ? this.activeGrantId : undefined;
    const idToken = await this.session.getProfile(grantId);
    if (await this.session.isLoggedIn()) {
      const grantResponse = await this.session.fetch(`grants/me`, _objectSpread({
        method: "GET"
      }, this.session.isMultiAccount() && this.activeGrantId ? {
        grant_id: this.activeGrantId
      } : {}));
      const grant = grantResponse.data;
      if (!idToken || !grant) {
        return null;
      }
      const grantEmail = grant.email;
      return {
        id: idToken.sub,
        email: grantEmail,
        name: idToken.name,
        provider: idToken.provider
      };
    }
    return null;
  }
  async authenticationUrl(authArgs) {
    var _context3;
    const provider = (authArgs == null ? void 0 : authArgs.provider) || "google";
    const defaultArgs = _findInstanceProperty(_context3 = this.defaultAuthArgs).call(_context3, args => args.provider === provider);
    let args = defaultArgs || {};
    if (authArgs) {
      args = _objectSpread(_objectSpread({}, args), authArgs);
    }
    return this.session.auth(args);
  }
  setDefaultAuthArgs(authArgs) {
    this.defaultAuthArgs = authArgs;
  }
}
export { NylasIdentityRequestWrapper as N };